import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { get, post } from '../lib/api';
type User={id:string;login:string;name:string;role:string};
type Auth={user:User|null;loading:boolean;login:(login:string,password:string)=>Promise<void>;logout:()=>Promise<void>;refresh:()=>Promise<void>};
const C=createContext<Auth|null>(null);
export function AuthProvider({children}:{children:ReactNode}){const[user,setUser]=useState<User|null>(null);const[loading,setLoading]=useState(true);
 const refresh=async()=>{try{const r=await get<{user:User}>('/api/auth/me');setUser(r.user)}catch{setUser(null)}finally{setLoading(false)}};
 useEffect(()=>{void refresh()},[]);
 const login=async(login:string,password:string)=>{const r=await post<{user:User}>('/api/auth/login',{login,password});setUser(r.user)};
 const logout=async()=>{await post('/api/auth/logout');setUser(null)};
 return <C.Provider value={{user,loading,login,logout,refresh}}>{children}</C.Provider>}
export function useAuth(){const v=useContext(C);if(!v)throw new Error('AuthProvider missing');return v}
